
/**
 *
 * @param {{
* month: string;
* date: number;
* size: "xs" | "sm" | "md" | "lg" | "xl";
* rounded: "none" | "sm" | "md" | "lg" | "xl" | "2xl" | "3xl" | "full";
* onClick: () => void;
* className: string;
* }}
*
*
*/

import { Fragment } from "react"

const DayCalender = ({
    month,
    date
}) => {
    return(
        <Fragment>
            <div className='w-[140px] bg-gradient-to-r from-[#64B5FF] to-[#6B95FF] rounded-t-[5px] py-[8px] text-center text-white text-[20px]'>
                {month}     
            </div>
            <div className='bg-[#EFEFEF] flex flex-row items-center justify-center text-[#555555] text-[34px] py-[20px] rounded-b-[5px]'>
                {date}
            </div>
        </Fragment>
    )
}
export default DayCalender